import React from 'react';

// Replace these imports with your actual images
import BannerImage from '../assets/logos/Banner.jpg';
import Img1 from '../assets/logos/Cardio.png';
import Img2 from '../assets/logos/Gastro.png';
import Img3 from '../assets/logos/Nephrology.png';
import Img4 from '../assets/logos/Pulmonology.png';
import Img5 from '../assets/logos/ENT.png';
import Img6 from '../assets/logos/EYE.png';
import Img7 from '../assets/logos/Mother&Childcare.png';
import Img8 from '../assets/logos/Dermotology.png';
import Img9 from '../assets/logos/Neuro.png';
import Img10 from '../assets/logos/Oncology.png';
import Img11 from '../assets/logos/Orthopedics.png';
import Img12 from '../assets/logos/TransplantMedicine.png';
import Img13 from '../assets/logos/Endrocrinology.png';
import Img14 from '../assets/logos/Robotics.png';
import Img15 from '../assets/logos/Dental.png';
import Img16 from '../assets/logos/Anaesthesia.png';
import Img17 from '../assets/logos/Emergency&CriticalCare.png';
import Img18 from '../assets/logos/Dietetics.png';
import Img19 from '../assets/logos/GeneralSurgery.png';

const ClinicalExcellenceBanner = () => {
  const gridItems = [
    { image: Img1, text: 'Cardiac Sciences' },
    { image: Img2, text: 'Gastro Sciences' },
    { image: Img3, text: 'Renal Sciences' },
    { image: Img4, text: 'Pulmonology' },
    { image: Img5, text: 'ENT' },
    { image: Img6, text: 'Eye / Opthalmology' },
    { image: Img7, text: 'Mother & Child Care' },
    { image: Img8, text: 'Dermatology & Cosmetic Care' },
    { image: Img9, text: 'Neuro Sciences' },
    { image: Img10, text: 'Oncology' },
    { image: Img11, text: 'Orthopaedics & Rheumatology' },
    { image: Img12, text: 'Transplant Medicine' },
    { image: Img13, text: 'Endocrinology' },
    { image: Img14, text: 'Robotic Sciences' },
    { image: Img15, text: 'Dental & Maxillofacial' },
    { image: Img16, text: 'Anaesthesia & Pain Management' },
    { image: Img17, text: 'Emergency & Critical Care' },
    { image: Img18, text: 'Dietetics' },
    { image: Img19, text: 'General Surgery' },
  ];

  const animations = "transition-transform duration-300 hover:scale-105 hover:shadow-xl";

  return (
    <div className="max-w-8xl ml-6 mr-6 p-6">
      {/* Heading Section */}
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold mb-4">Explore our Centre of Clinical Excellence</h1>
        <p className="text-gray-600 text-sm max-w-2xl mx-auto">
          TX Hospitals has dedicated Centres of Excellence for several key specialties and super specialties.
          They are unique and state-of-the-art facilities spread across several of the TX Hospital locations,
          and each Centre of Excellence stands out as a citadel of world-class clinical outcomes.
        </p>
        <h2 className="text-xl font-semibold mt-6">Learn about the world-class healthcare we provide</h2>
      </div>

      {/* Main Panel Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Panel */}
        <div className="flex items-center justify-center">
          <img
            src={BannerImage}
            alt="Banner"
            className="w-full max-w-lg rounded-md shadow-md"
          />
        </div>

        {/* Right Panel */}
        <div className="grid grid-cols-7 gap-4 mr-16">
          {gridItems.map((item, index) => (
            <div key={index} className="text-center">
              <div className={`w-full h-20 flex items-center justify-center overflow-hidden shadow-md  ${animations}`}>
                <img
                  src={item.image}
                  alt={`Service ${index + 1}`}
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-xs font-medium mt-2">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClinicalExcellenceBanner;
